<template>
  <div>
      <router-view></router-view>
  </div>
</template>
<script>
  export default {
    name: 'groupSettlement'
  }
</script>



// WEBPACK FOOTER //
// GroupSettlement.vue?2221197c